import { Button } from '@mui/material';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { PartnerData } from './ManageSubcontractorsModal';

interface DownloadSubcontractorPdfButtonProps {
  partners: PartnerData[];
  caption?: string;
}

export function DownloadSubcontractorPdfButton({ partners, caption }: DownloadSubcontractorPdfButtonProps) {
  const handleDownload = () => {
    const doc = new jsPDF();
    const title = caption || 'Subunternehmer-Liste';
    doc.setFontSize(16);
    const lines = doc.splitTextToSize(title, 180); // 180 is page width minus margins
    doc.text(lines, 14, 20);

    // Prepare table data
    const tableData = partners.map((p) => [p.partnerName, p.address || '', p.details || '']);
    autoTable(doc, {
      head: [['Name', 'Adresse', 'Details zur Datenweitergabe']],
      body: tableData,
      startY: 40,
      styles: { fontSize: 12 },
      headStyles: { fillColor: [120, 120, 120] }, // light grey background
    });

    // Add a footer
    const footerText = `Erstellt am: ${new Date().toLocaleDateString()} um ${new Date().toLocaleTimeString()}`;
    doc.setFontSize(10);
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth = doc.getTextWidth(footerText);
    const xPos = pageWidth - 14; // 14 is the right margin
    doc.text(footerText, xPos, doc.internal.pageSize.getHeight() - 10, {
      align: 'right',
    });

    doc.save('subunternehmer-liste.pdf');
  };

  return (
    <Button variant="outlined" onClick={handleDownload} sx={{ mb: 2 }}>
      Als PDF herunterladen
    </Button>
  );
}
